import { sanitizeReturnUrl } from "./sanitizeReturnUrl";

export const getAccountTargetUrl = (
	accountIndex: number,
	returnUrlParam: string | null
) => {
	const sanitizedReturnUrl = sanitizeReturnUrl(returnUrlParam);

	if (!sanitizedReturnUrl) {
		return accountIndex === 0 ? "/" : `/u/${accountIndex}`;
	}

	if (sanitizedReturnUrl.isAbsolute) {
		const url = new URL(sanitizedReturnUrl.url);
		url.searchParams.set("user_index", accountIndex.toString());
		return url.toString();
	}

	const normalizedReturnUrl =
		sanitizedReturnUrl.url.startsWith("/") ?
			sanitizedReturnUrl.url
		:	`/${sanitizedReturnUrl.url}`;

	if (normalizedReturnUrl.startsWith("/u/")) return normalizedReturnUrl;

	return accountIndex === 0 ? normalizedReturnUrl : (
			`/u/${accountIndex}${normalizedReturnUrl}`
		);
};
